module.exports = __webpack_public_path__ + "static/img/金鱼.99f5825.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/05/金鱼.jpg
// module id = CYb6
// module chunks = 7